module.exports = __webpack_public_path__ + "images/stickers/taco-reading@2x.7221a69f63ad71d6dfea.png";